import * as React from 'react';
import useProgress from '../hooks/useProgress';

function ProgressBar({ animate, time , isHidden}): React.ReactElement  {
  const progress = useProgress(animate, time);

  return (
    <div className={`carousel__progress-bar ${isHidden ? 'hidden' : 'visible'}`}>
      <div style={{ width: `${progress * 100}%` }} />
    </div>
  );
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/share/components/Carousel/components/ProgressBar.tsx